export default __webpack_public_path__ + "static/media/group_leader.7591d8ca.png";